var _createLegalTermsDocumentMutation;

import { graphql, commitMutation } from 'react-relay';
const createLegalTermsDocument = _createLegalTermsDocumentMutation !== void 0 ? _createLegalTermsDocumentMutation : _createLegalTermsDocumentMutation = require("./__generated__/createLegalTermsDocumentMutation.graphql");

function commit(environment, variables) {
  return new Promise((resolve, reject) => commitMutation(environment, {
    mutation: createLegalTermsDocument,
    variables: variables,
    onCompleted: function createLegalTermsDocumentCompleted(response) {
      resolve(response);
    },
    onError: reject
  }));
}

export default commit;